import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { DamageReportsRouteName } from '@pages/damage-reports-page/damage-reports.routes';
import { NEW_ENTITY_ROUTE_PARAM } from '@shared/constants/entity';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-damage-report-tabs',
  templateUrl: './damage-report-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DvTabsComponent, RouterOutlet],
})
export class DamageReportTabsComponent {
  private translate = inject(TranslateService);
  private router = inject(Router);

  private isNewEntity = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.router.url.includes(`/${NEW_ENTITY_ROUTE_PARAM}/`))
    ),
    { initialValue: this.router.url.includes(`/${NEW_ENTITY_ROUTE_PARAM}/`) }
  );

  tabLinks = computed<DvTabLink[]>(() =>
    [
      {
        label: this.translate.instant('DamageReports.Information'),
        link: DamageReportsRouteName.Information,
      },
      {
        label: this.translate.instant('DamageReports.Attachments'),
        link: DamageReportsRouteName.Attachments,
        disable: this.isNewEntity(),
      },
    ].map(tab => ({ ...tab, id: tab.link }))
  );
}
